import { Popper, Theme, Tooltip as BaseTooltip, TooltipProps as BaseTooltipProps } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

export type TooltipPlacement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

const LightPopper = styled(Popper)`
  ${({ theme }: { theme: Theme }): string => `
   & .MuiTooltip-tooltip {
      background-color: ${theme.colors.primaryBackground};
      color: ${theme.colors.primary};
      box-shadow: 0px 0.5px 1px rgba(20, 18, 51, 0.1), 0px 4px 8px rgba(20, 18, 51, 0.2);
      border-radius: 6px;
      font-weight: 400;
      font-size: 13px;
      line-height: 17px;
      padding: 12px;
      & .MuiTooltip-arrow {
        color: ${theme.colors.primaryBackground};
      }
    }
  `}
`;

const DarkPopper = styled(Popper)`
  ${({ theme }: { theme: Theme }): string => `
   & .MuiTooltip-tooltip {
      background-color: ${theme.colors.primary}D9;
      color: ${theme.colors.primaryBackground};
      box-shadow: 0px 0.5px 1px rgba(20, 18, 51, 0.1), 0px 4px 8px rgba(20, 18, 51, 0.2);
      border-radius: 6px;
      font-weight: 400;
      font-size: 13px;
      line-height: 17px;
      padding: 12px;
      & .MuiTooltip-arrow {
        color: ${theme.colors.primary}D9;
      }
    }
  `}
`;

interface TooltipProps extends BaseTooltipProps {
  type?: 'light' | 'dark';
}

const Tooltip: React.FC<TooltipProps> = ({ children, type = 'dark', ...props }: TooltipProps) => (
  <BaseTooltip leaveTouchDelay={5000} arrow PopperComponent={type === 'light' ? LightPopper : DarkPopper} {...props}>
    {children}
  </BaseTooltip>
);

export default Tooltip;
